<template>
  <div>
    <div class="user-info-head" @click="editCropper()"><img  :src="cropperOption.img?cropperOption.img:baseImg" title="点击上传图片" class="img-circle img-lg" /></div>
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body @opened="modalOpened">
      <el-row>
        <el-col :xs="24" :md="24" :style="{height: '350px'}">
          <vue-cropper
            ref="cropper"
            :img="cropperOption.img?cropperOption.img:baseImg"
            :info="true"
            :autoCrop="cropperOption.autoCrop"
            :autoCropWidth="cropperOption.autoCropWidth"
            :autoCropHeight="cropperOption.autoCropHeight"
            :fixedBox="cropperOption.fixedBox"
            @realTime="realTime"
            v-if="visible"
          />
        </el-col>
        <!-- <el-col :xs="20" :md="10" :style="{height: '350px'}">
          <div  class="avatar-upload-preview">
            <img :src="previews.url?previews.url:baseImg" :style="previews.img"  />
          </div>
        </el-col> -->
      </el-row>
      <br />
      <el-row>
        <el-col :lg="2" :md="2">
          <!-- <el-upload 
            :action="uploadImgUrl"
            :multiple='false'
            :on-change="handleUploadChange"
            name="file"
            :file-list="fileList"
            :show-file-list="false" 
            :before-upload="beforeUpload"
            accept='.jpg,.png'>
              <el-button size="small">
                选择
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
          </el-upload> -->

          <el-upload action="#" :http-request="requestUpload" :show-file-list="false" :before-upload="beforeUpload">
            <el-button size="small">
              选择
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
        </el-col>
        <el-col :lg="{span: 1, offset: 2}" :md="2">
          <el-button icon="el-icon-plus" size="small" @click="changeScale(1)"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-minus" size="small" @click="changeScale(-1)"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-refresh-left" size="small" @click="rotateLeft()"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-refresh-right" size="small" @click="rotateRight()"></el-button>
        </el-col>
        <el-col :lg="{span: 7, offset: 6}" :md="7">
          <el-button style="float: right;" type="primary" size="small" @click="uploadImg()">确 定</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import { getAction, postAction, uploadImage } from '@/request/http'//引入封装的get post方法

export default {
  components: { VueCropper },
  props: {
    cropperOption: {
      type: Object
    }
  },
  data() {
    return {
      // 是否显示弹出层
      open: false,
      // 是否显示cropper
      visible: false,
      // 弹出层标题
      title: "修改图片",
  
      previews: {},

      // uploadImgUrl: window._CONFIG['domianURL'] + "uploadImage", // 上传的图片服务器地址
    //   fileList:[],
      icon:'',
      // url:{
      //   uploadUrl:"/uploadImage",
      //  },
      baseImg:require('@/assets/img/baseUpload.jpg')
    };
  },
  methods: {
    // 编辑头像
    editCropper() {
      this.open = true;
    },
    // 打开弹出层结束时的回调
    modalOpened() {
      this.visible = true;
    },
    // 覆盖默认的上传行为
    requestUpload() {
    },
    // 向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    // 向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    // 图片缩放
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 上传预处理
    beforeUpload(file) {
      if (file.type.indexOf("image/") == -1) {
        this.msgError("文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。");
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.cropperOption.img = reader.result;
        };
      }
    },
    // 提交
    uploadImg() {
      this.$refs.cropper.getCropBlob(data => {
        console.log('data',data)
        let formData = new FormData();
        formData.append("file", data);
        uploadImage(formData).then(response => {
            console.log('response---',response)
            if(response.data.code==200){
                  this.cropperOption.img = window._CONFIG['uploadURL'] + response.data;

                  this.icon = response.data.data
                  this.$emit('giveIcon',this.icon)
                //   this.fileList=fileList
                //   this.$emit('giveFileList',this.fileList)
                
                
                  this.open = false;
                  this.msgSuccess("操作成功");
                  this.visible = false;
            }else{
                this.msgWarning(response.data.msg)
            }
          
        
        });
      });
    },
    // 实时预览
    realTime(data) {
      console.log('data----',data)
      this.previews = data;
      this.previews.img.width='200px'
      this.previews.img.height='150px'
      // this.previews.img.transform='scale(0.242786) translate3d(0px, 0px, 0px) rotateZ(0deg)'
      this.previews.img.transform=' translate3d(0px, 0px, 0px) '
      
    },

    // handleUploadChange(file, fileList){
    //     console.log('change,file',file)
    //     console.log('change,fileList',fileList)
    //     if(file.status=='success'){
    //         this.icon = file.response.data
    //         this.fileList=fileList

    //         // localStorage.setItem('IMGFILE',JSON.stringify(file))//
    //     }
    //     console.log('this.fileList==',this.fileList)

    //     this.$emit('giveFileList',this.fileList)
    //     this.$emit('giveIcon',this.icon)
    // },
    // uploadExceed(file, fileList){
    //     this.msgWarning('只限上传一张图片');
    // },
  }
};
</script>
<style scoped >
.user-info-head {
  position: relative;
  display: inline-block;
  /* height: 120px; */
  border: 1px solid #efefef;
}

.user-info-head:hover:after {
  content: '+';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  color: #eee;
  background: rgba(0, 0, 0, 0.5);
  font-size: 24px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: pointer;
  line-height: 190px;
  /* border-radius: 50%; */
}
.avatar-upload-preview {
	position: absolute;
	top: 50%;
	transform: translate(50%, -50%);
	width: 200px;
	height: 150px;
	/* border-radius: 50%; */
	box-shadow: 0 0 4px #ccc;
	overflow: hidden;
}
/* image */
.img-circle {
	/* border-radius: 50%; */
}

.img-lg {
	width: 266px;
	height: 200px;
}
</style>